import { Stack, Typography } from '@mui/material';
import { InlineBackdrop } from '@client/components/common/Backdrop';
import { Button } from '@client/components/common/Button';
import { useSelector } from '@client/hooks/redux.hooks';
import { getSessionUser } from '@client/selectors/helpers/session';
import { LoggedOut } from './LoggedOut';

export const AcceptInvitationCTA: React.FC<{ callback: () => void }> = ({ callback }) => {
  const user = useSelector(getSessionUser);

  if (!user) {
    return <LoggedOut />;
  }

  return (
    <InlineBackdrop color="success">
      <Stack spacing={3}>
        <div>
          <Typography
            variant="subtitle2"
            paragraph
          >
            Join the Show Team
          </Typography>

          <Typography color="textSecondary">
            Once you've joined the team you can see show stats and help manage the guest list.
          </Typography>
        </div>

        <Button
          variant="contained"
          size="large"
          color="success"
          onClick={callback}
          id="sda-invitations-accept-loggedinbutton"
          scope="accept-invitation"
          fullWidth
        >
          Accept Invitation
        </Button>
      </Stack>
    </InlineBackdrop>
  );
};
